import { render, staticRenderFns } from "./DeliveryCell.vue?vue&type=template&id=2a5d5823&"
import script from "./DeliveryCell.vue?vue&type=script&lang=ts&"
export * from "./DeliveryCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports